/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiNameExternalIdField
 */
export interface InternalApiNameExternalIdField {
    /**
     * 
     * @type {string}
     * @memberof InternalApiNameExternalIdField
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiNameExternalIdField
     */
    name?: string;
}

/**
 * Check if a given object implements the InternalApiNameExternalIdField interface.
 */
export function instanceOfInternalApiNameExternalIdField(value: object): value is InternalApiNameExternalIdField {
    return true;
}

export function InternalApiNameExternalIdFieldFromJSON(json: any): InternalApiNameExternalIdField {
    return InternalApiNameExternalIdFieldFromJSONTyped(json, false);
}

export function InternalApiNameExternalIdFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiNameExternalIdField {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function InternalApiNameExternalIdFieldToJSON(json: any): InternalApiNameExternalIdField {
    return InternalApiNameExternalIdFieldToJSONTyped(json, false);
}

export function InternalApiNameExternalIdFieldToJSONTyped(value?: InternalApiNameExternalIdField | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

